export default [
  {
    path: "/HzF97Sr9Azk2e0kY8w7w",
    children: [
      {
        path: "/MeyyMDHqJ",
        name: "userList",
        meta: {
          title: "User",
          authRequired: true,
          acc: ["y58017", "v12"],
        },
        component: () => import("../views/users/list.vue"),
      },
      {
        path: "RUhR4I/:id/RUh",
        name: "viewUser",
        meta: {
          title: "View User",
          authRequired: true,
          acc: ["y33810"],
        },
        component: () => import("../views/users/list.vue"),
      },
      {
        path: "/XPvhsBkD",
        name: "newUser",
        meta: {
          title: "New User",
          authRequired: true,
          acc: ["y35283"],
        },
        component: () => import("../views/users/new.vue"),
      },
    ],
  },
];
